import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import {
  ClearableNumberInputWithFrame,
  showClearButtonWhenValueIsNotZero,
} from '@flipster/features/src/input/clearable-number-input';
import { css } from '@flipster/styled-system/css';
import { flex, stack } from '@flipster/styled-system/patterns';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { formBunja } from '../bunja/form';
import { priceFormSegmentBunja } from '../bunja/price-form';

const LimitPriceForm = () => {
  const transTrade = useTranslations('Trade.r251104');
  const { limitPriceAtom, isBboAtom } = useBunja(formBunja);
  const { symbolInfoWithDefaultAtom } = useBunja(tradeSymbolBunja);

  const [limitPrice, setLimitPrice] = useAtom(limitPriceAtom);
  const symbolInfo = useAtomValue(symbolInfoWithDefaultAtom);
  const isBbo = useAtomValue(isBboAtom);
  const { trackTabPriceClearClick, trackTabPriceEditClick } = useBunja(priceFormSegmentBunja);

  const { pricePrecision, quoteCurrency } = symbolInfo;

  return (
    <div className={css({ pos: 'relative', w: '100%' })}>
      <div className={stack({ gap: 8, w: 'full' })}>
        {isBbo ? (
          <div
            className={flex({
              justify: 'space-between',
              align: 'center',
              height: 48,
              p: 12,
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'border.default.level-2',
              borderRadius: 4,
            })}
          >
            <div>{transTrade('Best_counterparty')}</div>
            <span className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-5' })}>
              {symbolInfo.quoteCurrency}
            </span>
          </div>
        ) : (
          <ClearableNumberInputWithFrame
            determineShowClearButton={showClearButtonWhenValueIsNotZero}
            value={limitPrice}
            precision={pricePrecision}
            currency={quoteCurrency}
            onChange={(p) => setLimitPrice(p || '0')}
            onFocus={trackTabPriceEditClick}
            onClearClick={trackTabPriceClearClick}
          />
        )}
      </div>
    </div>
  );
};

export default LimitPriceForm;
